import { useState } from "react";
import { Box, Text } from "@storyofams/react-ui";
import { showToast } from "~lib";
import { Button } from "~components/common/Button";
import { Input } from "~components/common/Input";
import backInStockNotification from "~lib/shopify/utils/backInStockNotification";

export const BackInStock = ({ id, variantId }) => {
  const [client, changeClient] = useState("");
  const handleClick = () => {
    const response = backInStockNotification("E-mail", id, variantId, client);
    response.then((res) => {
      if (res.data.status === "OK") {
        showToast("Verzonden!", "success");
        close();
        return;
      }
      switch (Object.keys(res.data.errors)[0]) {
        case "message":
          showToast("Voeg een e-mailadres of telefoonnummer toe", "error");
          break;
        case "email":
          showToast(
            "Het e-mailadres dat je hebt ingevoerd is niet correct",
            "error"
          );
          break;
        case "variant_no":
          showToast("Kies een productoptie", "error");
          break;
        case "phone_number":
          showToast(
            "Het telefoonnummer dat je hebt ingevoerd is ongeldig. Voeg een telefoonnummer toe met de landcode",
            "error"
          );
          break;
        default:
          showToast("Je staat al ingeschreven!", "info");
          break;
      }
    });
  };
  return (
    <Box mt={1}>
      <Input
        width="100%"
        customHeight="36px"
        name="email"
        id="email"
        label="E-mailadres*"
        type="email"
        value={client}
        onChange={(event) => changeClient(event.target.value)}
      />
      <Button
        customHeight={"42px"}
        customPY={0}
        variant="primary"
        mt={1}
        onClick={handleClick}
        width="100%"
      >
        <Text fontSize={"16px"} fontWeight="500">
          Hou mij op de hoogte
        </Text>
      </Button>
    </Box>
  );
};
